var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-wrap"},[_c('iframe',{staticClass:"frame",attrs:{"src":("/pdfjs/web/viewer.html?file=" + (encodeURIComponent(_vm.fileUrl))),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }